import { forwardRef } from "react";
import { Tree } from "react-arborist";
import { AiFillFolder, AiFillFile } from "react-icons/ai";
import { MdArrowRight, MdArrowDropDown } from "react-icons/md";
const CommonTree = forwardRef(function CommonTree(
  { data, childrenAccessor, onSelect },
  ref
) {
  data = data || [
    { id: "1", name: "Unread" },
    { id: "2", name: "Threads" },
    {
      id: "3",
      name: "Chat Rooms",
      children: [
        { id: "c1", name: "General" },
        { id: "c2", name: "Random" },
        { id: "c3", name: "Open Source Projects" },
      ],
    },
    {
      id: "4",
      name: "Direct Messages",
      children: [
        { id: "d1", name: "Alice" },
        { id: "d2", name: "Bob" },
        { id: "d3", name: "Charlie" },
      ],
    },
  ];

  function Node({ node, style, dragHandle, tree }) {
    /* This node instance can do many things. See the API reference. */
    // console.log(node.isLeaf, node.data);
    // const label = !node.isLeaf ? node.data.payer_type : node.data.payer_name;
    return (
      <div className="node-container" style={style} ref={dragHandle}>
        <div className="node-content">
          {node.isLeaf ? (
            <>
              <span className="arrow"></span>
              <span className="file-folder-icon">
                <AiFillFile color="#6bc7f6" />
              </span>
            </>
          ) : (
            <>
              <span
                className="arrow"
                onClick={() => node.isInternal && node.toggle()}
              >
                {node.isOpen ? <MdArrowDropDown /> : <MdArrowRight />}
              </span>
              <span className="file-folder-icon">
                <AiFillFolder color="#f6cf60" />
              </span>
            </>
          )}
          <span className="node-text">
            {node.isSelected ? (
              <strong>{node.data.name}</strong>
            ) : (
              node.data.name
            )}
          </span>
        </div>
      </div>
    );
  }
  return (
    <Tree
      ref={ref}
      data={data}
      //   onSelect={(nodes) => {
      //     console.log(nodes);
      //   }}
      childrenAccessor={childrenAccessor}
      disableMultiSelection={true}
      // width={260}
      height={350}
      indent={24}
      rowHeight={32}
      onSelect={onSelect}
    >
      {Node}
    </Tree>
  );
});

export default CommonTree;
